import { AbilitySubject, every, not } from "@cdv/jazz-auth";
import { User } from "../../api";
import { isAppuser } from "../utils";

export default function defineTestDefinitionAbility(can: AbilitySubject<User>): void {
  can("read");
  can(["update", "create"], not(isAppuser));
  can("sync", isAppuser);
}
